import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-pilates': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-pilates&exp=web_tiers_as_upgrade_pilates~1
			upsell: {
				routeNames: ['upsell-pilates-f', 'upsell-upgrade-pilates-f'],
			},
			upgrade: {
				routeName: null,
			},
		},
	},
]

export default config
